module.exports = __webpack_public_path__ + "static/media/211IT070.0e91460b.jpeg";